"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _ = require("../");

var _ChipSelect = _interopRequireDefault(require("./ChipSelect.sizes"));

var _ChipSelect2 = _interopRequireDefault(require("./ChipSelect.theme"));

var _styles = require("./styles");

var _excluded = ["id", "name", "badge", "badgeColor", "checked", "className", "label", "disabled", "labelFontSize", "leftIcon", "status", "variant", "rightIcon", "theme", "type", "value", "style"];
var ChipSelect = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name,
      badge = _ref.badge,
      badgeColor = _ref.badgeColor,
      checked = _ref.checked,
      className = _ref.className,
      label = _ref.label,
      disabled = _ref.disabled,
      labelFontSize = _ref.labelFontSize,
      leftIcon = _ref.leftIcon,
      status = _ref.status,
      variant = _ref.variant,
      rightIcon = _ref.rightIcon,
      theme = _ref.theme,
      type = _ref.type,
      value = _ref.value,
      style = _ref.style,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var chipSelectId = id || name;
  var appearance = (0, _ChipSelect2.default)(theme.colors.primary, type);
  var fieldClassNames = [className];
  var chipSize = (0, _ChipSelect.default)(theme).sm;

  if (checked) {
    fieldClassNames.push("checked");
  }

  if (disabled) {
    fieldClassNames.push("disabled");
  }

  return /*#__PURE__*/_react.default.createElement(_styles.ChipBox, {
    className: fieldClassNames.join(' '),
    appearance: appearance,
    size: chipSize,
    style: style
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, {
    htmlFor: chipSelectId
  }, checked && type === 'checked' && /*#__PURE__*/_react.default.createElement(_styles.FieldIcon, null, /*#__PURE__*/_react.default.createElement(_styles.CheckIcon, null)), leftIcon && /*#__PURE__*/_react.default.createElement(_styles.FieldIcon, null, leftIcon), label, badge && /*#__PURE__*/_react.default.createElement(_styles.FieldIcon, {
    className: "icon-right"
  }, /*#__PURE__*/_react.default.createElement(_.Badge, {
    color: badgeColor,
    disabled: disabled
  }, badge)), rightIcon && /*#__PURE__*/_react.default.createElement(_styles.FieldIcon, {
    className: "icon-right"
  }, rightIcon)), /*#__PURE__*/_react.default.createElement(_styles.CheckboxHidden, Object.assign({
    ref: ref,
    id: chipSelectId,
    name: name,
    value: value,
    type: "checkbox",
    disabled: disabled,
    checked: checked
  }, rest)));
});
ChipSelect.defaultProps = {
  appearance: 'color',
  disabled: false,
  type: 'checked'
};

var _default = (0, _styledComponents.withTheme)(ChipSelect);

exports.default = _default;